import React from 'react';
import styled from 'styled-components';
import { font, ChartCell } from './sharedStyles';
import { getColumnBorderFlags } from './columnBorderFlags';
import type { CellTextAlign } from '../cellAlignment';

const EDGE_PADDING = '12px';

const NumberFloatWrapper = styled.div<{ $align: CellTextAlign }>`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 9px !important;
  text-align: ${({ $align }) => $align};
  padding-left: ${({ $align }) => ($align === 'left' ? EDGE_PADDING : '0')};
  padding-right: ${({ $align }) => ($align === 'right' ? EDGE_PADDING : '5px')};
`;

const NumberFloatCellWrapper = styled.div<{ $align: CellTextAlign }>`
  margin-top: 5px;
  ${font}
  letter-spacing: -0.3px;
  text-align: ${({ $align }) => $align};
`;

export const NumberFloatRenderer =
  (
    firstColumnIds: Set<string>,
    lastColumnIds: Set<string>,
    columnIds: string[],
    hasScroll: boolean | undefined,
    textAlign: CellTextAlign = 'center',
  ) =>
  // eslint-disable-next-line react/display-name
  ({ cellData, columnIndex }: any) => {
    const { isFirst, isLast } = getColumnBorderFlags(columnIds, columnIndex, firstColumnIds, lastColumnIds, hasScroll);
    return (
      <ChartCell $isfirst={isFirst ? 1 : 0} $islast={isLast ? 1 : 0}>
        <NumberFloatWrapper $align={textAlign}>
          <NumberFloatCellWrapper $align={textAlign}>{cellData}</NumberFloatCellWrapper>
        </NumberFloatWrapper>
      </ChartCell>
    );
  };
